
    import I18n from 'i18nObj';
    
      import 'translations/models_conversations';
      import 'translations/_core';
    
    import 'translations/_core_en';

    export default I18n.scoped('models_conversations');
  